// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dispatch-page-order-leg-stop-info {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 180px;
  max-width: 180px;
}

  .dispatch-page-order-leg-stop-info__inputs {
    display: flex;
    align-items: center;
  }

  .dispatch-page-order-leg-stop-info__cpy-btn {
    margin-right: 3px;
  }

  .dispatch-page-order-leg-stop-info__display-field {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    font-weight: 500;
  }

  .dispatch-page-order-leg-stop-info__editable-field {
    border-bottom: 0;
  }

  .dispatch-page-order-leg-stop-info__outgate-ingate-text .r-editable-field__text {
      font-style: italic;
    }

  .dispatch-page-order-leg-stop-info__stop-container {
    display: flex;
    flex-direction: column;
  }

  .dispatch-page-order-leg-stop-info__stop-container-sync-border {
      position: relative;
      border: 1px solid #d9dbde;
      border-radius: 5px;
      margin-right: 10px;
      padding: 5px;
      width: 100%;
    }

  .dispatch-page-order-leg-stop-info__stop-container-sync-border--enabled {
        border-color: #276de2;
      }

  .dispatch-page-order-leg-stop-info__sync-button {
    position: absolute;
    right: 4px;
    cursor: pointer;
    width: 13px;
    height: 13px;
    color: #d9dbde;
  }

  .dispatch-page-order-leg-stop-info__sync-button--enabled {
      color: #276de2;
    }

  .dispatch-page-order-leg-stop-info__actions {
    display: flex;
    align-items: center;
  }

  .dispatch-page-order-leg-stop-info__actions > * {
      margin-left: 6px;
    }

  .dispatch-page-order-leg-stop-info__actions > *:first-child {
        margin-left: 0;
      }

  .dispatch-page-order-leg-stop-info__actions-right {
    display: flex;
    align-items: center;
    margin-left: 12px;
    height: 100%;
  }

  .dispatch-page-order-leg-stop-info__instruction-indicator {
    width: 15px;
    color: #276de2;
    margin-right: 6px;
    cursor: pointer;
  }

  .dispatch-page-order-leg-stop-info__request-del-appt-btn-container {
    display: flex;
    color: #276de2;
    cursor: pointer;
    font-style: italic;
  }

  .dispatch-page-order-leg-stop-info__gate-ticket-icon {
    width: 11px;
    height: 14px;
    margin-right: 6px;
    cursor: pointer;
    color: var(--color-grayscale-5);
  }

  .dispatch-page-order-leg-stop-info__gate-ticket-icon--enabled {
      color: #276de2;
    }

  .dispatch-page-order-leg-stop-info__trash-icon {
    width: 14px;
    height: 14px;
    cursor: pointer;
    margin: 5px 0;
    margin-left: 8px;
  }

  .dispatch-page-order-leg-stop-info__trash-icon:hover {
      color: red;
    }

  .dispatch-page-order-leg-stop-info__robot-icon {
      width: 17px;
      margin-right: 3px;
      color: #00b22d;
    }

  .dispatch-page-order-leg-stop-info__robot-container {
      display: flex;
      align-items: center;
      color: #00b22d;
      font-style: italic;
      font-weight: 600;
    }

  .dispatch-page-order-leg-stop-info__icon--disabled {
    color: var(--color-grayscale-5);
    pointer-events: none;
    cursor: none;
  }

  .dispatch-page-order-leg-stop-info__icon--disabled:hover {
      color: var(--color-grayscale-5);
    }

  .dispatch-page-order-leg-stop-info__location-info {
    display: flex;
    flex-direction: column;
    padding-right: 5px;
  }

  .dispatch-page-order-leg-stop-info__location-info-name {
      height: 19px !important;
      min-height: 19px !important;
    }

  .dispatch-page-order-leg-stop-info__location-info-name input {
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
        font-weight: 500;
      }

  .dispatch-page-order-leg-stop-info__location-info-name * {
        font-weight: 500;
      }

  .dispatch-page-order-leg-stop-info__location-info-name .r-editable-field__input input {
          font-weight: 500;
        }

  .dispatch-page-order-leg-stop-info__location-info-city {
      height: 19px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

  .dispatch-page-order-leg-stop-info__times {
    margin-top: 8px;
    padding-right: 5px;
  }

  .dispatch-page-order-leg-stop-info__times > * {
      margin-top: 4px;
    }

  .dispatch-page-order-leg-stop-info__times > *:first-child {
        margin-top: 0;
      }
`, "",{"version":3,"sources":["webpack://./app/pages/DispatchPage/components/DispatchPageOrderLegStopInfo/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAkMlB;;EAhME;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAGE;MACE,kBAAkB;IACpB;;EAGF;IACE,aAAa;IACb,sBAAsB;EAcxB;;EAZE;MACE,kBAAkB;MAClB,yBAAyB;MACzB,kBAAkB;MAClB,kBAAkB;MAClB,YAAY;MACZ,WAAW;IAKb;;EAHE;QACE,qBAAqB;MACvB;;EAIJ;IACE,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,WAAW;IACX,YAAY;IACZ,cAAc;EAKhB;;EAHE;MACE,cAAc;IAChB;;EAGF;IACE,aAAa;IACb,mBAAmB;EASrB;;EAPE;MACE,gBAAgB;IAKlB;;EAHE;QACE,cAAc;MAChB;;EAIJ;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,+BAA+B;EAKjC;;EAHE;MACE,cAAc;IAChB;;EAGF;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;EAKlB;;EAHE;MACE,UAAU;IACZ;;EAIA;MACE,WAAW;MACX,iBAAiB;MACjB,cAAc;IAChB;;EAEA;MACE,aAAa;MACb,mBAAmB;MACnB,cAAc;MACd,kBAAkB;MAClB,gBAAgB;IAClB;;EAGF;IACE,+BAA+B;IAC/B,oBAAoB;IACpB,YAAY;EAKd;;EAHE;MACE,+BAA+B;IACjC;;EAGF;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EAgCpB;;EA9BE;MACE,uBAAuB;MACvB,2BAA2B;IAoB7B;;EAlBE;QACE,cAAc;QACd,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,WAAW;QACX,gBAAgB;MAClB;;EAEA;QACE,gBAAgB;MAClB;;EAGE;UACE,gBAAgB;QAClB;;EAIJ;MACE,YAAY;MACZ,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;IAClB;;EAGF;IACE,eAAe;IACf,kBAAkB;EASpB;;EAPE;MACE,eAAe;IAKjB;;EAHE;QACE,aAAa;MACf","sourcesContent":[".dispatch-page-order-leg-stop-info {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 180px;\n  max-width: 180px;\n\n  &__inputs {\n    display: flex;\n    align-items: center;\n  }\n\n  &__cpy-btn {\n    margin-right: 3px;\n  }\n\n  &__display-field {\n    display: block;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 100%;\n    font-weight: 500;\n  }\n\n  &__editable-field {\n    border-bottom: 0;\n  }\n\n  &__outgate-ingate-text {\n    & .r-editable-field__text {\n      font-style: italic;\n    }\n  }\n\n  &__stop-container {\n    display: flex;\n    flex-direction: column;\n\n    &-sync-border {\n      position: relative;\n      border: 1px solid #d9dbde;\n      border-radius: 5px;\n      margin-right: 10px;\n      padding: 5px;\n      width: 100%;\n\n      &--enabled {\n        border-color: #276de2;\n      }\n    }\n  }\n\n  &__sync-button {\n    position: absolute;\n    right: 4px;\n    cursor: pointer;\n    width: 13px;\n    height: 13px;\n    color: #d9dbde;\n\n    &--enabled {\n      color: #276de2;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n\n    & > * {\n      margin-left: 6px;\n\n      &:first-child {\n        margin-left: 0;\n      }\n    }\n  }\n\n  &__actions-right {\n    display: flex;\n    align-items: center;\n    margin-left: 12px;\n    height: 100%;\n  }\n\n  &__instruction-indicator {\n    width: 15px;\n    color: #276de2;\n    margin-right: 6px;\n    cursor: pointer;\n  }\n\n  &__request-del-appt-btn-container {\n    display: flex;\n    color: #276de2;\n    cursor: pointer;\n    font-style: italic;\n  }\n\n  &__gate-ticket-icon {\n    width: 11px;\n    height: 14px;\n    margin-right: 6px;\n    cursor: pointer;\n    color: var(--color-grayscale-5);\n\n    &--enabled {\n      color: #276de2;\n    }\n  }\n\n  &__trash-icon {\n    width: 14px;\n    height: 14px;\n    cursor: pointer;\n    margin: 5px 0;\n    margin-left: 8px;\n\n    &:hover {\n      color: red;\n    }\n  }\n\n  &__robot {\n    &-icon {\n      width: 17px;\n      margin-right: 3px;\n      color: #00b22d;\n    }\n\n    &-container {\n      display: flex;\n      align-items: center;\n      color: #00b22d;\n      font-style: italic;\n      font-weight: 600;\n    }\n  }\n\n  &__icon--disabled {\n    color: var(--color-grayscale-5);\n    pointer-events: none;\n    cursor: none;\n\n    &:hover {\n      color: var(--color-grayscale-5);\n    }\n  }\n\n  &__location-info {\n    display: flex;\n    flex-direction: column;\n    padding-right: 5px;\n\n    &-name {\n      height: 19px !important;\n      min-height: 19px !important;\n\n      & input {\n        display: block;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        width: 100%;\n        font-weight: 500;\n      }\n\n      & * {\n        font-weight: 500;\n      }\n\n      & .r-editable-field__input {\n        & input {\n          font-weight: 500;\n        }\n      }\n    }\n\n    &-city {\n      height: 19px;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    }\n  }\n\n  &__times {\n    margin-top: 8px;\n    padding-right: 5px;\n\n    & > * {\n      margin-top: 4px;\n\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
